import { getHarmonyAppDefinitions } from '@office-start/mos-app-utilities';
import { cleanupOldOfficeHomeSideloadData, getPrefixedKey } from '../utils';
export const localStorage = getLocalStorage();
function getLocalStorage() {
    let storage = undefined;
    try {
        storage = window.localStorage;
    }
    catch (error) {
        console.error(`Access to LocalStorage has been blocked! ${error}`);
    }
    return storage;
}
export const getLocalStorageSideloadApps = (puid) => {
    if (!localStorage) {
        console.error('Cannot save locally sideloaded apps with falsy localStorage.');
        return;
    }
    const key = getPrefixedKey(puid);
    try {
        cleanupOldOfficeHomeSideloadData(key);
        const appsJson = localStorage.getItem(key) || '[]';
        const acquisitionResponse = {
            acquisitions: JSON.parse(appsJson),
            syncKey: '',
            nextInterval: '',
            isFreshSyncKey: false,
        };
        return getHarmonyAppDefinitions(acquisitionResponse.acquisitions);
    }
    catch (err) {
        console.error(`Problem loading locally sideloaded apps: ${err}`);
    }
    return undefined;
};
//# sourceMappingURL=getLocalStorageSideloadApps.js.map